var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.808C18.2063 20.808 20.8055 18.2089 20.8055 15.0026C20.8055 11.7963 18.2063 9.19711 15 9.19711C11.7937 9.19711 9.19453 11.7963 9.19453 15.0026C9.19453 18.2089 11.7937 20.808 15 20.808ZM29.95 15.0026C29.95 23.2592 23.2567 29.9526 15 29.9526C6.74334 29.9526 0.05 23.2592 0.05 15.0026C0.05 6.74593 6.74334 0.0525826 15 0.0525826C23.2567 0.0525826 29.95 6.74593 29.95 15.0026Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.808C18.2063 20.808 20.8055 18.2089 20.8055 15.0026C20.8055 11.7963 18.2063 9.19711 15 9.19711C11.7937 9.19711 9.19453 11.7963 9.19453 15.0026C9.19453 18.2089 11.7937 20.808 15 20.808ZM29.95 15.0026C29.95 23.2592 23.2567 29.9526 15 29.9526C6.74334 29.9526 0.05 23.2592 0.05 15.0026C0.05 6.74593 6.74334 0.0525826 15 0.0525826C23.2567 0.0525826 29.95 6.74593 29.95 15.0026Z",
    stroke: "url(#paint0_linear_227_211)",
    strokeWidth: 0.108
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.808C18.2063 20.808 20.8055 18.2089 20.8055 15.0026C20.8055 11.7963 18.2063 9.19711 15 9.19711C11.7937 9.19711 9.19453 11.7963 9.19453 15.0026C9.19453 18.2089 11.7937 20.808 15 20.808ZM29.95 15.0026C29.95 23.2592 23.2567 29.9526 15 29.9526C6.74334 29.9526 0.05 23.2592 0.05 15.0026C0.05 6.74593 6.74334 0.0525826 15 0.0525826C23.2567 0.0525826 29.95 6.74593 29.95 15.0026Z",
    stroke: "url(#paint1_linear_227_211)",
    strokeWidth: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_211",
    x1: -0.632321,
    y1: -3.59223,
    x2: 21.3241,
    y2: 5.87725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_227_211",
    x1: 32.2219,
    y1: 36.8401,
    x2: 21.1925,
    y2: 33.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedEllipse);
export default __webpack_public_path__ + "static/media/RedEllipse.9565a0f84efb426ee77d5d80d3550de2.svg";
export { ForwardRef as ReactComponent };